import { IconType } from "react-icons/lib";
import styled from "styled-components";

const CardWrapper = styled.div`
  width: fit-content;
  padding: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.bg.prim_500};
  color: ${({ theme }) => theme.text.prim_50};

  .l-info {
    display: flex;
    align-items: start;
    gap: 1rem;
    h3 {
      font-weight: 400;
      font-size: 1rem;
    }

    h2 {
      font-size: 1.2rem;
      font-weight: bold;
      span {
        font-size: 0.85rem;
        color: ${({ theme }) => theme.text.prim_200};
        font-weight: 400;
      }
    }
  }
`;

export interface IAccountCardStat {
  icon: IconType;
  title: string;
  item: string;
  value: number;
}

export function AccountantStat({
  icon: Icon,
  title,
  item,
  value,
}: IAccountCardStat) {
  return (
    <CardWrapper>
      <div className="l-info">
        <Icon color="red" size={15} />
        <div>
          <h2>{title}</h2>
          <h3>{item}</h3>
          <h2>
            {value} unit{value > 1 ? "s" : null}
          </h2>
        </div>
      </div>
    </CardWrapper>
  );
}
